module.exports = __webpack_public_path__ + "static/media/EMPOWER-v1.0.4aba8c08.jpg";